export default __webpack_public_path__ + "c9118b6f75fdf0d70a1f42b7ebbd33f8.png";